export default __webpack_public_path__ + "static/media/resnetgru1.8940d720.png";